import React, { useState, useEffect } from 'react';
import SearchOptions from './ExhibitorSearch/SearchOptions';
import qs from 'qs';
import FinderResults from './ExhibitorSearch/FinderResults';
import ExhibitorProfile from './ExhibitorSearch/ExhibitorProfile';
import autoload from '../../helpers/autoload';

const Exhibitor25Container = ({ convention_id }) => {
  const [searchFilter, setSearchFilter] = useState({ exhibitor_type: [], tags: [] });
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedExhibitor, setSelectedExhibitor] = useState(null);
  const [isApiReady, setIsApiReady] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 992);

  // Handle window resize for responsive behavior
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 992);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Parse query parameters from URL on initial render
  useEffect(() => {
    let exhibitor_type = [];
    let tags = [];
    const queryParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    
    setSearchQuery(queryParams.search || '');
    
    if (typeof queryParams.exhibitor_type === 'string') {
      exhibitor_type = [queryParams.exhibitor_type];
    } else if (queryParams.exhibitor_type) {
      exhibitor_type = queryParams.exhibitor_type;
    }
    
    if (typeof queryParams.tags === 'string') {
      tags = [queryParams.tags];
    } else if (queryParams.tags) {
      tags = queryParams.tags;
    }
    
    setSearchFilter({ exhibitor_type, tags });
    setIsApiReady(true);
  }, []);

  const handleSearchQueryChange = search => {
    setSearchQuery(search.replace('&', '%26').replace('#', '%23'));
  };

  // Update URL parameters when search state changes
  useEffect(() => {
    const exhibitorTypeArray = searchFilter?.exhibitor_type || [];
    const tagsArray = searchFilter?.tags || [];
    
    const exhibitorTypeParams = exhibitorTypeArray
      .map(type => `exhibitor_type=${encodeURIComponent(type)}`)
      .join('&');
    
    const tagsParams = tagsArray
      .map(tag => `tags=${encodeURIComponent(tag)}`)
      .join('&');

    let queryString = '';
    if (searchQuery) {
      queryString += `search=${encodeURIComponent(searchQuery)}`;
    }
    if (exhibitorTypeParams) {
      queryString += (queryString ? '&' : '') + exhibitorTypeParams;
    }
    if (tagsParams) {
      queryString += (queryString ? '&' : '') + tagsParams;
    }
    
    const newURL = queryString === '' ? window.location.pathname : `?${queryString}`;
    window.history.replaceState({}, '', newURL);
  }, [searchQuery, searchFilter]);

  const safeSetSearchFilter = newFilter => {
    if (!newFilter) return;
    
    const safeFilter = {
      exhibitor_type: Array.isArray(newFilter.exhibitor_type) ? newFilter.exhibitor_type : [],
      tags: Array.isArray(newFilter.tags) ? newFilter.tags : [],
      ...newFilter,
    };
    setSearchFilter(safeFilter);
  };

  const handleExhibitorSelect = (exhibitor) => {
    setSelectedExhibitor(exhibitor);
  };

  const handleProfileClose = () => {
    setSelectedExhibitor(null);
  };

  return (
    <div className={`exhibitor-interface ${selectedExhibitor && !isLargeScreen ? 'profile-open' : ''}`}>
      {(!selectedExhibitor || isLargeScreen) && (
        <div className={`exhibitor-content ${isLargeScreen ? 'two-column' : 'single-column'}`}>
          <div className={`exhibitor-main-panel ${selectedExhibitor && isLargeScreen ? 'with-profile' : ''}`}>
            <SearchOptions
              search={searchQuery}
              filters={searchFilter}
              onQueryChange={handleSearchQueryChange}
              setSearchFilter={safeSetSearchFilter}
              conventionId={convention_id}
            />
            
            <FinderResults
              search={searchQuery}
              conventionId={convention_id}
              searchFilter={searchFilter}
              isApiReady={isApiReady}
              onExhibitorSelect={handleExhibitorSelect}
              selectedExhibitor={selectedExhibitor}
            />
          </div>
          
          {selectedExhibitor && isLargeScreen && (
            <div className="exhibitor-profile-container">
              <ExhibitorProfile
                exhibitorId={selectedExhibitor.id}
                conventionId={convention_id}
                onClose={handleProfileClose}
                isLargeScreen={isLargeScreen}
              />
            </div>
          )}
        </div>
      )}
      
      {selectedExhibitor && !isLargeScreen && (
        <div className="exhibitor-content profile-only">
          <ExhibitorProfile
            exhibitorId={selectedExhibitor.id}
            conventionId={convention_id}
            onClose={handleProfileClose}
            isLargeScreen={isLargeScreen}
          />
        </div>
      )}
    </div>
  );
};

export default autoload(Exhibitor25Container, 'exhibitor-25-container');